import React, { useEffect, useState } from "react"
import Chart from "react-apexcharts"
import ApexCharts from "apexcharts"
import { FaDownload } from "react-icons/fa"
import API from "../../api"

// eslint-disable-next-line react/prop-types
const StatsGradeEnseignant = ({ width = "100%", height = 500 }) => {
  const [series, setSeries] = useState([])
  const [labels, setLabels] = useState([])

  const userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  const annee_id = userAuthScolarite?.user?.annee_id

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await API.post("enseignant/stat_ens_grade", { annee_id })
        const data = response.data.result

        // Extraire les grades et les nombres
        const grades = data.map((item) => item.grade)
        const nombres = data.map((item) => item.nombre_enseignants)

        setLabels(grades)
        setSeries([
          {
            name: "Nombre enseignants",
            data: nombres,
          },
        ])
      } catch (error) {
        console.error("Erreur lors du chargement des statistiques :", error)
      }
    }

    fetchData()
  }, [annee_id])

  const options = {
    chart: {
      id: "barChartGrades", // 🟢 ID unique pour ApexCharts.exec()
      type: "bar",
      height: height,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "60%",
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => val,
      style: {
        fontSize: "12px",
        colors: ["#000"],
      },
    },
    xaxis: {
      categories: labels.length ? labels : ["Chargement..."],
      labels: {
        style: { fontSize: "12px" },
      },
    },
    colors: ["#1E90FF"],
    tooltip: {
      y: {
        formatter: (val) => val,
      },
    },
    // title: {
    //   text: "Statistique des grades enseignants",
    //   align: "center",
    //   style: { fontSize: "20px",  color: "#ffa1b5" ,fontWeight:"600"},
    // },
  }

  const handleDownload = () => {
    ApexCharts.exec("barChartGrades", "dataURI").then(({ imgURI }) => {
      const link = document.createElement("a")
      link.href = imgURI

      // Ajout de la date au nom du fichier 📅
      const today = new Date().toISOString().split("T")[0]
      link.download = `Statistique_des_grades_enseignants_${today}.png`

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }

  return (
    <div style={{ textAlign: "center" }}>
      <h3 style={{ color: "#ffa1b5" }}>Statistique des grades enseignants</h3>

      <FaDownload
        onClick={handleDownload}
        title="Télécharger le graphique"
        style={{
          cursor: "pointer",
          marginBottom: "10px",
          color: "#E91E63",
          fontSize: "20px",
        }}
      />

      <div style={{ maxWidth: "800px", margin: "0 auto" }}>
        <Chart
          options={options}
          series={series}
          type="bar"
          width={width}
          height={height}
        />
      </div>
    </div>
  )
}

export default StatsGradeEnseignant
